// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentConfig, version } from './_environment';

export const environment: EnvironmentConfig = {
  production: false,
  version,
  language: 'enCa',
  api: {
    autoAuthenticate: true,
    allowGuest: true,
    spoke: 'oceanbottom'
  },
  stripeApi:
    'pk_test_51JDTBeGby6mhvox6UZCukF3BzVIAhphCFh58ZMBKqM0PrediRrDo1PNteszUg5LXviHhiPSP36BcJX4UkuE1bp0o00blyWAmNP'
};
